import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "sb-resp-ui";

export class BetBtn extends React.Component<{ modifier?: string, handler?: Function, odds?: string, isDisabled?: boolean }, {}> {
    render() {
        return (
            <Col modifier="rj-racing-next-races__col--odds">
                <CMP.BetBtn
                    modifier={this.props.modifier}
                    type={CMP.BetBtnTypes.Odd}
                    handler={this.props.handler}
                    odd={this.props.odds}
                    isDisabled={this.props.isDisabled}
                    dataUat="button-next-races-odds-selection"
                />
            </Col>
        )
    }
}